import { useCallback, useEffect, useRef } from "react";

export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function selectHashes(h) {
  return document.querySelectorAll(`[title="${h}"]`)
}

export function b64toBlob(b64Data, contentType = '', sliceSize = 512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

export function bytesTob64(arraybuffer) {
  // This is SOOOOO stupid; there must be a better way in 2024...
  if (!arraybuffer) return "";
  let bytes = new Uint8Array(arraybuffer);
  let str = "";
  for (let i=0; i < bytes.length; i++) {
    str += String.fromCharCode(bytes[i]);
  }
  return window.btoa(str)
}

export function jsonTryParse(str) {
  try {
    return JSON.parse(str)
  } catch (_) {
    return str;
  }
}

export function toDTG(date) { // This format barely readable; why not YYYY-MM-DD HH:MM:SS
  // Ensure the date is a Date object
  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  // Day of the month with leading zero
  let day = String(date.getUTCDate()).padStart(2, '0');

  // Hours in 24-hour format with leading zero
  let hours = String(date.getUTCHours()).padStart(2, '0');

  // Minutes with leading zero
  let minutes = String(date.getUTCMinutes()).padStart(2, '0');

  // Month as three letter abbreviation
  const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  // let month = monthNames[date.getUTCMonth()];
  let month = String(date.getUTCMonth()).padStart(2, '0');
  // Full year
  let year = date.getUTCFullYear();

  return `${month}/${day}/${year} ${hours}:${minutes} (UTC)`;

  // Combine all parts into the DTG format
  return `${day}${hours}${minutes}Z${month}${year}`;
}

export function useClickOutside(callback, ref) {

  // Based on:
  // - https://stackoverflow.com/a/54292872
  // - https://www.youtube.com/watch?v=J-g9ZJha8FE&feature=youtu.be&t=481

  let handleClickOutside = useCallback((e) => {
    if (!ref?.current?.contains(e.target) && callback) {
      callback(e);
    }
  }, [ref]);

  useEffect(() => {
    if (ref?.current) {
      document.addEventListener("click", handleClickOutside, true);
      return () => {
        document.removeEventListener("click", handleClickOutside, true);
      }
    }
  }, [ref.current, handleClickOutside]);

  return ref;
}

export function useEscapeKey(callback) {
  let handleEscKey = useCallback((event) => {
    if (event.key == "Escape") {
      callback(event);
    }
  }, [callback]);

  useEffect(() => {
    document.addEventListener("keyup", handleEscKey, false);
    return () => {
      document.removeEventListener("keyup", handleEscKey, false);
    };
  }, [handleEscKey]);
}

export function mapObject(obj, pred) {
  return Object.fromEntries(Object.entries(obj).map(pred));
}

export function filterObject(obj, pred) {
  return Object.fromEntries(Object.entries(obj).filter(pred));
}
